// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"8088ebf52ad9bf0d","9998":"d246bc5e7b5a733a"}[chunkId] + ".css";
};